module.exports = __webpack_public_path__ + "media/images/emoticons/despair-051f3bbe339669834bdae6112aefdd1c.gif";